import { Component, input } from '@angular/core';

@Component({
  selector: 'wk8-progress-lights',
  imports: [],
  templateUrl: './wk8-progress-lights.component.html',
  styleUrl: './wk8-progress-lights.component.css',
})
export class Wk8ProgressLightsComponent {
  numSteps = input(4);
  numCompleted = input(0);
}
